import { render, staticRenderFns } from "./CmgBagGroupOrderDetails.vue?vue&type=template&id=4463a70a&scoped=true&lang=pug&"
import script from "./cmg-bag-group-order-details.ts?vue&type=script&lang=ts&"
export * from "./cmg-bag-group-order-details.ts?vue&type=script&lang=ts&"
import style0 from "./CmgBagGroupOrderDetails.vue?vue&type=style&index=0&id=4463a70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4463a70a",
  null
  
)

export default component.exports